/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { compareWindows } from 'modules/common/ui-controller';

export const COMPARISON_RADIO_OPTIONS = [
  'Previous Week',
  'Previous Month',
  'Previous Year',
  'OTB',
  'Custom',
];

export const API = {
  GET_ALL_SCENARIOS: {
    path: '/organizations/:organizationId/scenarios?:query',
    method: 'GET',
  },
  GET_FAVORITE_SCENARIOS: {
    path: '/organizations/:organizationId/users/:userId/configurations/scenario-favorites',
    method: 'GET',
  },
  GET_SEARCH_SCENARIOS: {
    path: '/organizations/:organizationId/scenarios/search?:query',
    method: 'GET',
  },
  UPDATE_FAVORITE_SCENARIOS: {
    path: '/organizations/:organizationId/users/:userId/configurations/scenario-favorites/:scenarioId',
    method: 'PATCH',
  },
};

export const COMMON_FOCUS_ON_OPTIONS = {
  OVERALL: { label: '\u200BTotal', id: 0 },
  SELECT_ALL: { label: '\u200BSelect All', id: 1 },
};

export const FILTERS = {
  PMS: 'PMS',
  BOOKING_WINDOW: 'Booking Window',
  BOOKING_HORIZON: 'Booking Horizon',
  MOVING_AVERAGE: 'Moving Average',
  BREAKDOWN: 'Breakdown',
  VS_HOTEL: 'VS HOTEL',
  TIME_COMPARISON: 'Dashboard Time Comparison',
  WEEKLY_CUMULATIVE: 'Weekly Cumulative Window',
  LAG_ALIGNED_WINDOW: 'Lag Aligned Window',
  PERCENTAGE: 'Percentage',
};

export const VISUAL_FILTER_MAPPER = {
  TREND: [
    FILTERS.PMS,
    FILTERS.BOOKING_WINDOW,
    FILTERS.MOVING_AVERAGE,
    FILTERS.BREAKDOWN,
    FILTERS.VS_HOTEL,
    FILTERS.TIME_COMPARISON,
    FILTERS.WEEKLY_CUMULATIVE,
  ],
  PACE: [
    FILTERS.PMS,
    FILTERS.BOOKING_WINDOW,
    FILTERS.BREAKDOWN,
    FILTERS.VS_HOTEL,
    FILTERS.TIME_COMPARISON,
    FILTERS.LAG_ALIGNED_WINDOW,
    FILTERS.BOOKING_HORIZON,
    FILTERS.PERCENTAGE,
  ],
  DASHBOARD: [FILTERS.PMS, FILTERS.BOOKING_WINDOW, FILTERS.VS_HOTEL, FILTERS.TIME_COMPARISON],
};

export const FILTER_TO_COMPARISON_MAP = {
  'Previous Year': compareWindows.py,
  'Previous Week': compareWindows.pw,
  'Previous Month': compareWindows.pm,
  OTB: compareWindows.otb,
  Custom: compareWindows.cus,
};
export const COMPARISON_TO_FILTER_MAP = {
  [compareWindows.py]: 'Previous Year',
  [compareWindows.pw]: 'Previous Week',
  [compareWindows.pm]: 'Previous Month',
  [compareWindows.otb]: 'OTB',
  [compareWindows.cus]: 'Custom',
};

export const SCENARIO_FILTERS = {
  STAY_DATE: 'stayDate',
  FOCUS_ON: 'focusOn',
  HOTEL: 'hotel',
  BOOKING_PACE_HORIZON: 'bookingPaceHorizon',
  PERCENTAGE: 'percentage',
  BOOKING_DATE: 'bookingDate',
  BREAKDOWN: 'breakdown',
  HOTEL_SET: 'hotelSet',
  COMPARISON_PERIOD: 'comparisonPeriod',
  COMPARISON_ALIGNMENT: "comparisonAlignment"
};
